var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#6610F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1832 111V41.1818H69.3651C74.7287 41.1818 79.2287 42.1818 82.8651 44.1818C86.5242 46.1818 89.2855 48.9318 91.1492 52.4318C93.0355 55.9091 93.9787 59.8636 93.9787 64.2955C93.9787 68.7727 93.0355 72.75 91.1492 76.2273C89.2628 79.7045 86.4787 82.4432 82.7969 84.4432C79.1151 86.4205 74.581 87.4091 69.1946 87.4091H51.8423V77.0114H67.4901C70.6264 77.0114 73.1946 76.4659 75.1946 75.375C77.1946 74.2841 78.6719 72.7841 79.6264 70.875C80.6037 68.9659 81.0923 66.7727 81.0923 64.2955C81.0923 61.8182 80.6037 59.6364 79.6264 57.75C78.6719 55.8636 77.1832 54.3977 75.1605 53.3523C73.1605 52.2841 70.581 51.75 67.4219 51.75H55.831V111H43.1832ZM162.339 41.1818V111H151.089L118.192 63.4432H117.612V111H104.964V41.1818H116.283L149.146 88.7727H149.76V41.1818H162.339ZM222.893 63.4773C222.325 61.6364 221.541 59.9886 220.541 58.5341C219.564 57.0568 218.382 55.7955 216.996 54.75C215.632 53.7045 214.064 52.9205 212.291 52.3977C210.518 51.8523 208.587 51.5795 206.496 51.5795C202.746 51.5795 199.405 52.5227 196.473 54.4091C193.541 56.2955 191.234 59.0682 189.553 62.7273C187.893 66.3636 187.064 70.7955 187.064 76.0227C187.064 81.2955 187.893 85.7614 189.553 89.4205C191.212 93.0795 193.518 95.8636 196.473 97.7727C199.428 99.6591 202.859 100.602 206.768 100.602C210.314 100.602 213.382 99.9205 215.973 98.5568C218.587 97.1932 220.598 95.2614 222.007 92.7614C223.416 90.2386 224.121 87.2841 224.121 83.8977L226.984 84.3409H208.03V74.4545H236.359V82.8409C236.359 88.8182 235.087 93.9886 232.541 98.3523C229.996 102.716 226.496 106.08 222.041 108.443C217.587 110.784 212.473 111.955 206.7 111.955C200.268 111.955 194.621 110.511 189.757 107.625C184.916 104.716 181.132 100.591 178.405 95.25C175.7 89.8864 174.348 83.5227 174.348 76.1591C174.348 70.5227 175.143 65.4886 176.734 61.0568C178.348 56.625 180.598 52.8636 183.484 49.7727C186.371 46.6591 189.757 44.2955 193.643 42.6818C197.53 41.0455 201.757 40.2273 206.325 40.2273C210.189 40.2273 213.791 40.7955 217.132 41.9318C220.473 43.0455 223.439 44.6364 226.03 46.7045C228.643 48.7727 230.791 51.2273 232.473 54.0682C234.155 56.9091 235.257 60.0455 235.78 63.4773H222.893Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 194,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 153.668,
    y: 235.668,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 195.332,
    y: 194,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 235.668,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 277.332,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 153.668,
    y: 319,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 195.332,
    y: 277.332,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 319,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 278.668,
    y: 194,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 320.332,
    y: 235.668,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 278.668,
    y: 277.332,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 320.332,
    y: 319,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 360.668,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 153.668,
    y: 402.332,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 195.332,
    y: 360.668,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 402.332,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 278.668,
    y: 360.668,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 320.332,
    y: 402.332,
    width: 41.6667,
    height: 41.6667,
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_694",
    x: 31.1836,
    y: 40.2266,
    width: 209.176,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_694",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.6ca29c82fa9af633f11b013868211401.svg";
export { ForwardRef as ReactComponent };